import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';

import { environment } from '@unico-people/ongoing-dashboard/enviroment';
import * as fromStore from '@unico-people/shared/dashboard/data-access-store';

import {
  ResponseSkillTrial
} from '../../interfaces/requests.model';
import { SessionStorage } from '@unico-people/shared/utils/storage';

@Injectable({ providedIn: 'root' })
export class SkillService {
  private url: string = environment.url;
  acc = SessionStorage.getItem('currentAccount');

  constructor(private http: HttpClient, private store: Store<any>) {
    this.store.pipe(select(fromStore.getOrganizationState)).subscribe(res => {
      this.acc = res?.currentAccount?.uid;
    });
  }

  getUnicoSkillTrial(): Observable<any> {
    return this.http.get<ResponseSkillTrial>(`${this.url}/skills/license-trial`);
  }

  activeSkillTrial(data: number[]): Observable<any> {
    return this.http.patch<any>(`${this.url}/skills/trial`, data);
  }
}
